<template>
  <div class="pagination text-center">
    <button type="button" class="page-link page-first link"
      @click.stop="changePage(1)"
      v-if="page > 2">
      <i class="fas fa-angle-double-left"></i>
    </button>
    <button type="button" class="page-link page-previous link"
      v-if="page > 1" @click.stop="changePage(previousPage)">
      <i class="fas fa-angle-left"></i>
    </button>
    <div v-for="n in lastPage" :key="n">
      <button type="button"
        :class="{ active: isActivePage(n) }"
        class="page-link link"
        @click.stop="changePage(n)"
        v-if="showPaginate(n)">
        <span>{{ n }}</span>
      </button>
    </div>
    <button type="button" class="page-link page-next link"
      @click.stop="changePage(nextPage)"
      v-if="page < lastPage || !page">
      <i class="fas fa-angle-right"></i>
    </button>
    <button type="button" class="page-link page-last link"
      @click.stop="changePage(lastPage)"
      v-if="page < (lastPage - 1) || !page">
      <i class="fas fa-angle-double-right"></i>
    </button>
  </div>
</template>


<script>
export default {
  props: ['lastPage', 'currentPage'],
  computed: {
    page() {
      return this.currentPage || 1;
    },
    limitPage() {
      if (this.page) {
        return parseInt(this.page, 10) + 4;
      }
      return 4;
    },
    nextPage() {
      return parseInt(this.page, 10) + 1;
    },
    previousPage() {
      return parseInt(this.page, 10) - 1;
    },
  },
  methods: {
    showPaginate(n) {
      if ((n < this.limitPage && n >= this.page) || this.lastPage < 5) {
        return true;
      }

      if ((this.lastPage - n) < 4 && (this.lastPage - this.page) < 4) {
        return true;
      }
      return false;
    },
    isActivePage(n) {
      if (!this.page) {
        return n === 1;
      }
      return this.page.toString() === n.toString();
    },
    changePage(n) {
      this.$emit('update:currentPage', n);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.pagination {
  display: flex;
}

.page-link {
  color: $primary;
  background: transparent;
  border: none;
  margin: 0 $spacer * 0.25;
  border-radius: 4px;
  color: #4d4d4c;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
}

.page-link:last-child {
  margin-right: 0;
}

.page-link.active {
  background-color: lighten($primary, 75%);
  color: darken($primary, 5%);
}

.page-previous {
  margin-right: $spacer;
}

.page-next {
  margin-left: $spacer;
}

.page-first, .page-previous, .page-next, .page-last {
  background-color: $gray-100;
}

</style>
